import { useState } from "react";

import Grid from "@Components/Grid";
import Button from "@Components/Button";
import useGetRoles from "@Hooks/useRoles";
import TextField from "@Components/Inputs/TextField";
import { CreateTeamRequest, Team } from "@Types/teams";

import styles from "./Team.module.scss";
import MultiSelect from "@Components/Inputs/MultiSelect";
import { Role } from "@Types/roles";

type Props<T extends Team | CreateTeamRequest> = {
  id: string;
  type: "update" | "create";
  initialState: T;
  handleSubmit: (
    e: React.FormEvent<HTMLFormElement>,
    user: T | undefined
  ) => void;
};
export function TeamForm<T extends Team | CreateTeamRequest>({
  id,
  type,
  initialState,
  handleSubmit,
}: Props<T>) {
  const [state, setState] = useState(initialState);
  const { data: roles, isFetching: isFetchingRoles } = useGetRoles();

  return (
    <div className={styles.formContainer}>
      <form data-testid={id} id={id} onSubmit={(e) => handleSubmit(e, state)}>
        <Grid container xs={12} spacing={2}>
          <Grid xs={12}>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "22px",
              }}
            >
              Name
            </div>
          </Grid>
          <Grid xs={12}>
            <div
              style={{
                fontSize: "20px",
              }}
            >
              This name should be clear, so it allows perfect understanding of
              what the role enables users to do.
            </div>
          </Grid>

          <Grid xs={4}>
            <TextField
              onChange={(e) =>
                setState((prev) => ({
                  ...(prev ?? {}),
                  data: {
                    ...(prev?.data ?? {}),
                    info: {
                      ...(prev?.data?.info ?? {}),
                      name: e.target.value,
                    },
                  },
                }))
              }
              id="Name"
              placeholder="Name"
              value={state?.data.info.name ?? ""}
              name="Name"
              type="text"
              required
            />
          </Grid>

          <Grid
            container
            xs={12}
            style={{ marginBottom: "20px", paddingLeft: "10px" }}
          >
            <Grid xs={12}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "22px",
                }}
              >
                Roles
              </div>
            </Grid>
            <Grid xs={12}>
              <div
                style={{
                  fontSize: "20px",
                }}
              >
                This permissions will be applied to each teammate with in this
                team. Multiple roles can be selected.
              </div>
            </Grid>
            <Grid xs={4}>
              <MultiSelect<Role>
                placeholder="Select roles"
                getOptionSelected={(x, y) => x._id === y._id}
                options={roles ?? []}
                required
                id="role-select"
                name="role-select"
                loading={isFetchingRoles}
                value={state?.data.roles ?? []}
                onChange={(roles) =>
                  setState((prev) => ({
                    ...prev,
                    data: {
                      ...prev?.data,
                      roles,
                    },
                  }))
                }
                getOptionLabel={(role) => role.data.info.name}
              />
            </Grid>
          </Grid>

          <Grid xs={12}>
            <Button
              style={{ width: "30%" }}
              form={id}
              id={`${type}-user-button`}
              variant="gradient"
              type="submit"
            >
              {type === "create" ? "Create Team" : "Save Changes"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
}
